var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMasterCard = function SvgMasterCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 16,
    x: 0.5,
    y: 3.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    fillRule: "evenodd",
    d: "M12.224 15.429a5.22 5.22 0 0 1-3.402 1.254 5.25 5.25 0 0 1-5.244-5.252c0-2.9 2.348-5.251 5.244-5.251a5.22 5.22 0 0 1 3.402 1.254 5.22 5.22 0 0 1 3.401-1.254 5.25 5.25 0 0 1 5.245 5.251c0 2.9-2.348 5.252-5.245 5.252a5.22 5.22 0 0 1-3.401-1.255",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    fillRule: "evenodd",
    d: "M12.224 15.429a5.24 5.24 0 0 0 1.842-3.998c0-1.6-.715-3.034-1.842-3.997a5.22 5.22 0 0 1 3.401-1.255 5.25 5.25 0 0 1 5.245 5.252c0 2.9-2.348 5.252-5.245 5.252a5.22 5.22 0 0 1-3.401-1.255",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    fillRule: "evenodd",
    d: "M12.224 15.429a5.24 5.24 0 0 0 1.842-3.998c0-1.6-.715-3.034-1.842-3.997a5.24 5.24 0 0 0-1.843 3.997c0 1.6.715 3.034 1.843 3.998",
    clipRule: "evenodd"
  })));
};
export default SvgMasterCard;